export default "<div [ngClass]=\"className\">\r\n\t<ng-content></ng-content>\r\n</div>\r\n"